(function ($, Drupal) {
  Drupal.behaviors.exit = {
    attach: function (context, settings) {

      once('exit', '.js-exit', context).forEach((e) => {
        $(e).on('click touch',function(e) {
          window.location.replace('https://www.google.de/');
        });
      });

      if (settings.user.uid === 0) {
        once('exit-no-history', 'a:not(.toggle-button', context).forEach((e) => {
          $(e).on('click touch', function(e) {
            if ($(this).attr('href').charAt(0) !== '#') {
              e.preventDefault();
              var linkURL = this.href;
              if ($(this).attr('target') !== '_blank') {
                window.location.replace(linkURL);
              } else {
                window.open(linkURL, '_blank');
              }
            }
          });
        });

      }
    }
  }
})(jQuery, Drupal);
